import React from 'react';
import { PlusCircle, Calendar } from 'lucide-react';
import { useTheme } from './ThemeContext';

const QuickActions = ({ onNavigate }) => {
  const { colors } = useTheme();

  const handleNewJob = () => {
    // Paid work — defaults to "full" workflow (quote → sign → schedule)
    onNavigate('express-job', { workflowType: 'full' });
  };

  return (
    <>
      {/* Quick Actions Section */}
      <div style={{
        background: colors.bgCard,
        border: `2px solid ${colors.accent}`,
        borderRadius: '12px',
        padding: '2rem',
        marginBottom: '2rem'
      }}>
        <h2 style={{
          fontSize: '1.5rem',
          fontWeight: 'bold',
          color: colors.text,
          marginBottom: '1.5rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <span style={{ color: colors.accent }}>⚡</span>
          Quick Actions
        </h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(250px, 100%), 1fr))',
          gap: '1rem'
        }}>
          {/* New Job - Primary Action (paid work) */}
          <button
            onClick={handleNewJob}
            style={{
              background: `linear-gradient(135deg, ${colors.accent} 0%, #F0895C 100%)`,
              border: 'none',
              borderRadius: '12px',
              padding: '1.5rem',
              cursor: 'pointer',
              transition: 'all 0.2s',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '0.75rem',
              boxShadow: '0 4px 12px rgba(240, 90, 40, 0.3)'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(240, 90, 40, 0.4)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(240, 90, 40, 0.3)';
            }}
          >
            <PlusCircle size={32} color="#fff" />
            <div style={{ textAlign: 'left' }}>
              <div style={{
                fontSize: '1.3rem',
                fontWeight: 'bold',
                color: '#fff',
                marginBottom: '0.25rem'
              }}>
                New Job
              </div>
              <div style={{
                fontSize: '0.85rem',
                color: 'rgba(255, 255, 255, 0.9)'
              }}>
                Create paid work with pricing & signature
              </div>
            </div>
          </button>

          {/* View Planning */}
          <button
            onClick={() => onNavigate('planning')}
            style={{
              background: colors.bgInput,
              border: `2px solid ${colors.info}`,
              borderRadius: '12px',
              padding: '1.5rem',
              cursor: 'pointer',
              transition: 'all 0.2s',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '0.75rem'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.background = colors.border;
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.background = colors.bgInput;
            }}
          >
            <Calendar size={32} color={colors.info} />
            <div style={{ textAlign: 'left' }}>
              <div style={{
                fontSize: '1.3rem',
                fontWeight: 'bold',
                color: colors.text,
                marginBottom: '0.25rem'
              }}>
                View Planning
              </div>
              <div style={{
                fontSize: '0.85rem',
                color: colors.textMuted
              }}>
                Manage your schedule
              </div>
            </div>
          </button>
        </div>
      </div>
    </>
  );
};

export default QuickActions;
